import { ToastType, toast } from '@elliemae/ds-toast';

// Own toast container so these notifications don't collide with the header's.
export const EXCEPTION_TOAST_CONTAINER_ID = 'eligibility-exception';

// Success toast shown after an eligibility exception is saved.
export const showExceptionAppliedToast = (programName: string): void => {
  toast(
    {
      type: ToastType.SUCCESS,
      messageTitle: 'Success - Eligibility Exception Applied',
      messageText: programName,
    },
    { containerId: EXCEPTION_TOAST_CONTAINER_ID, autoClose: 5000 },
  );
};

// Error toast shown when saving or re-qualifying an exception fails.
export const showExceptionErrorToast = (): void => {
  toast(
    {
      type: ToastType.ERROR,
      messageTitle: 'Unable to Apply Eligibility Exception',
      messageText: 'Something went wrong. Please try again.',
    },
    { containerId: EXCEPTION_TOAST_CONTAINER_ID, autoClose: 5000 },
  );
};

// Success toast shown after an eligibility exception is deleted.
export const showExceptionDeletedToast = (programName: string): void => {
  toast(
    {
      type: ToastType.SUCCESS,
      messageTitle: 'Exception Deleted',
      messageText: programName,
    },
    { containerId: EXCEPTION_TOAST_CONTAINER_ID, autoClose: 5000 },
  );
};

// Error toast shown when deleting or re-qualifying after a delete fails.
export const showExceptionDeleteErrorToast = (): void => {
  toast(
    {
      type: ToastType.ERROR,
      messageTitle: 'Unable to Delete Eligibility Exception',
      messageText: 'Something went wrong. Please try again.',
    },
    { containerId: EXCEPTION_TOAST_CONTAINER_ID, autoClose: 5000 },
  );
};
